import * as React from "react";
import { ToastProvider } from "react-toast-notifications";

import RootContainer from "./Containers/RootContainer";

const App: React.SFC<{}> = () => {
  return (
    <ToastProvider placement="bottom-center">
      <RootContainer />
    </ToastProvider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx